import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Plug, ArrowRight } from "lucide-react";

/**
 * Friendly empty-state card shown when an integration (Firecrawl/Tavily) isn't configured.
 * No scary error toasts — this is the inline alternative.
 */
export function IntegrationEmptyState({
  integration = "firecrawl",
  variant = "card", // "card" (full block) | "compact" (inside modal)
}) {
  const { t } = useTranslation(["errors", "common"]);
  const titleKey = `${integration}_not_configured.title`;
  const bodyKey = `${integration}_not_configured.body`;
  const ctaKey = `${integration}_not_configured.cta`;

  const padding =
    variant === "compact" ? "px-5 py-5" : "px-8 py-10";
  const iconSize = variant === "compact" ? "h-9 w-9" : "h-11 w-11";

  return (
    <div
      data-testid={`integration-empty-${integration}`}
      className={`flex flex-col items-start gap-4 rounded-2xl border border-amber-200 bg-amber-50/60 ${padding}`}
    >
      <div
        className={`flex ${iconSize} items-center justify-center rounded-xl bg-amber-100 text-amber-700`}
      >
        <Plug className="h-5 w-5" strokeWidth={1.75} />
      </div>
      <div className="space-y-1">
        <h3 className="font-display text-base font-semibold tracking-tight text-amber-950">
          {t(`errors:${titleKey}`)}
        </h3>
        <p className="text-sm leading-relaxed text-amber-900/80">
          {t(`errors:${bodyKey}`)}
        </p>
      </div>
      <Link
        to="/settings/integrations"
        data-testid={`integration-empty-cta-${integration}`}
        className="inline-flex items-center gap-1 rounded-lg bg-amber-900 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-amber-950"
      >
        {t(`errors:${ctaKey}`)} <ArrowRight className="h-3.5 w-3.5" strokeWidth={2} />
      </Link>
    </div>
  );
}
